enum ActiveValues {
  /**
   * @deprecated Should use 'New' instead
   */
  All = 'all',
  New = 'new',
  ShortList = 'shortlisted',
  OfferSent = 'offerSent',
  requestInterview = 'requestInterview',
  declined = 'declined',
  hired = 'hired',
  find = 'find',
  interested = 'interested',
}

export default ActiveValues;
